import { inject } from '@angular/core';
import { type CanActivateFn, RedirectCommand, Router } from '@angular/router';

import { TaxUserService } from '../service';

/**
 * 签名守卫：检查路径上是否存在 signature 参数
 * 存在则将 signature 和 businessLicenseInfoSheetId 存入 TaxUserService，不存在则拦截并重定向到结果页
 */
export const signatureGuard: CanActivateFn = (route) => {
  const userSrv = inject(TaxUserService);
  const router = inject(Router);

  const signature = route.queryParams['signature'];
  if (!signature) {
    return new RedirectCommand(
      router.parseUrl(`/tax/result?msg=${encodeURIComponent('缺少签名参数，请联系工作人员')}`),
    );
  }

  const businessLicenseInfoSheetId = route.queryParams['businessLicenseInfoSheetId'];
  if (!businessLicenseInfoSheetId || isNaN(Number(businessLicenseInfoSheetId))) {
    return new RedirectCommand(
      router.parseUrl(`/tax/result?msg=${encodeURIComponent('缺少营业执照信息表ID参数，请联系工作人员')}`),
    );
  }

  userSrv.signature.set(signature);
  userSrv.routeBusinessLicenseInfoSheetId.set(Number(businessLicenseInfoSheetId));
  return true;
};
